import PaneContainer from '@/layouts/components/PaneContainer'
import SingleColumn from '@/layouts/SingleColumn'
import { useState } from 'react'
import Welcome from './sections/Welcome'
import CurrentFile from './sections/CurrentFile'

function Dashboard() {
  return (
    <SingleColumn>
      <PaneContainer>
        <div className="tm-grid tm-grid-cols-1 gap-4 w-9 mx-auto">
          <h1 className="text-2xl font-medium mb-3">ダッシュボード</h1>
          <Welcome />
          <CurrentFile />
        </div>
      </PaneContainer>
    </SingleColumn>
  )
}

export default Dashboard
